import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { TestimonialCaptureAPI } from '../../services/testimonialCaptureAPI';

@inject(Router)
export class Decline {
    constructor(router) {
        this.router = router;

        this.loading = true;
        this.error = false;
        this.consent = false;
        this.capture_key = false;
        this.api = false;

        this.logo_img = "images/magnfi-logo-small.png";
        this.app_name = "Magnfi";


        this.home_url = window.home_url;
        this.site_url = window.site_url;
        this.supportEmail = window.support_email;
        if(window.whitelabel) {
          this.whitelabel = window.whitelabel;
          this.logo_img = "api/whitelabel/getFile?file=site_logo";
          this.app_name = window.app_name;

        }
    }
    consent_clicked(){
        this.consent = true;

        this.api.decline(
                {
                    capture_key: this.capture_key,
                    consent: true
                },
                this.apiSuccess.bind(this),
                this.apiError.bind(this));
    }
    activate(model) {
        this.loading = false;
        this.capture_key = model.key;
        this.api = new TestimonialCaptureAPI(parseInt(model.type));

        /*this.api.decline(
                {
                    capture_key: this.capture_key,
                    consent: false
                },
                this.apiSuccess.bind(this),
                this.apiError.bind(this));*/


    }

    apiSuccess() {
        this.loading = false;
        this.consent = true;

    }

    apiError(msg) {
        this.loading = false;
        this.error = true;
    }




}
